/* eslint-disable react/prop-types */
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import MDButton from "components/MDButton";
import { styled } from "@mui/material/styles";
import StyledComponent from "styled-components";

const Style = StyledComponent.div`
  .row {
    display: flex;
    border-bottom: 1px solid #eee;
    marging-bottom: 10px;
    .label {
      width: 30%;
      padding: 5px 10px;
      font-weight: bold;
      border-right: 1px solid #eee;
      border-left: 1px solid #eee;
      display: flex;
      align-items: center;
    }
    .data {
      width: 70%;
      padding: 5px 10px;
      border-right: 1px solid #eee;
      &.text-center{
        text-align: center;
      }
    }
  }
`;
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function Modal({ open, handleClose, data }) {
  return open ? (
    <BootstrapDialog aria-labelledby="customized-dialog-title" open={open}>
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        Punches details
      </BootstrapDialogTitle>
      <DialogContent dividers style={{ width: 576 }} className="punches-details">
        <Style>
          {data.settings && data.settings.collectIP ? (
            <div>
              <div className="row">
                <div className="label">Clock In IP</div>
                <div className="data">{data.clockInIp}</div>
              </div>
              <div className="row">
                <div className="label">Clock Out IP</div>
                <div className="data">{data.clockOutIp}</div>
              </div>
            </div>
          ) : null}
          {data.settings && data.settings.profileImage ? (
            <div>
              <div className="row">
                <div className="label">Profile Image</div>
                <div className="data text-center">
                  {data.profileImageUrl ? (
                    <img src={data.profileImageUrl} alt={`${data.fullName} profile`} />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : null}
          {data.settings && data.settings.signShift ? (
            <div>
              <div className="row">
                <div className="label">Signature</div>
                <div className="data text-center">
                  {data.signatureUrl ? (
                    <img src={data.signatureUrl} alt={`${data.fullName} Signature`} />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </Style>
      </DialogContent>

      <DialogActions>
        <MDButton onClick={handleClose} type="button" variant="gradient" color="secondary">
          Close
        </MDButton>
      </DialogActions>
    </BootstrapDialog>
  ) : null;
}
